module.exports = __webpack_public_path__ + "media/photo/telecom2-cd72eff1.jpg";